<template>
	<sf-data-table
		ref="carSaleTable"
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		paging
		:columns="columns"
		:rows="carSaleList"
		:stripe="false"
		:selection="false"
		@changedPage="changedPage"
		height="500px"
	>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/comm/commpopup/CarSalePopup/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return [
				{
					label: this.getMessage_('QWCC001538'), //PMC Id
					prop: 'pmcId',
					minWidth: '180px',
					clickEvent: this.scrNameClick,
					sortable: false,
					highlight: true
				},
				{
					label: this.getMessage_('QWCC000974'), //PMC No
					prop: 'pmcNo',
					minWidth: '180px',
					sortable: false,
					highlight: true
				},
				{
					label: this.getMessage_('QWCC001008'), //HTWO 법인
					prop: 'htwoCorpNm',
					minWidth: '140px',
					sortable: false,
					highlight: false
				},
				{
					label: this.getMessage_('QWCC001044'), // HTWO판매일
					prop: 'erpSaleDd',
					minWidth: '130px',
					sortable: false,
					highlight: false
				},
				{
					label: this.getMessage_('SWCC000015'), // 공장
					prop: 'plntNm',
					minWidth: '110px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001009'), //JV업체명
					prop: 'jvCpnyNm',
					minWidth: '150px',
					sortable: false,
					highlight: false
				},
				{
					label: this.getMessage_('QWCC001010'), //JV판매일
					prop: 'jvSaleDd',
					minWidth: '130px',
					sortable: false,
					highlight: true
				},
				{
					label: this.getMessage_('QWCC002099'), // SI업체명
					prop: 'siCpnyNm',
					width: '100px',
					headerAlign: 'center'
				},
				{
					label: this.getMessage_('QWCC002101'), // SI판매일
					prop: 'siSaleDd',
					width: '130px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001541'), //OEM법인명
					prop: 'oemCpnyNm',
					minWidth: '150px',
					sortable: false,
					highlight: false
				},
				{
					label: this.getMessage_('QWCC001012'), //OEM판매일
					prop: 'oemSaleDd',
					minWidth: '130px',
					sortable: false,
					highlight: false
				},
				{
					label: this.getMessage_('QWCC001013'), //고객사업체명
					prop: 'custNm',
					minWidth: '180px',

					sortable: false,
					highlight: true
				},
				{
					label: this.getMessage_('QWCC001015'), //차량구분
					prop: 'carScnNm',
					minWidth: '110px',
					sortable: false,
					highlight: false
				},
				{
					label: this.getMessage_('QWCC000960'), //차량VIN
					prop: 'carVin',
					minWidth: '150px',
					sortable: false,
					highlight: false
				},
				{
					label: this.getMessage_('QWCC001016'), //차량유형
					prop: 'carTypeNm',
					minWidth: '150px',
					sortable: false,
					highlight: false
				},
				{
					label: this.getMessage_('QWCC001017'), //승상구분
					prop: 'pacScnNm',
					minWidth: '120px',
					sortable: false,
					highlight: false
				},
				{
					label: this.getMessage_('QWCC001018'), //동력유형
					prop: 'pwrTypeNm',
					minWidth: '150px',
					sortable: false,
					highlight: false
				},
				{
					label: this.getMessage_('MWPP000074'), //판매국가
					prop: 'saleNatNm',
					minWidth: '150px',
					sortable: false,
					highlight: false
				},
				{
					label: this.getMessage_('QWCC001019'), // 판매지역
					prop: 'saleRegnNm',
					minWidth: '150px',
					sortable: false,
					highlight: false
				},
				{
					label: this.getMessage_('QWCC001020'), //판매지역의 상세지역
					prop: 'dtlRegn',
					minWidth: '150px',
					sortable: false,
					highlight: false
				},
				{
					label: this.getMessage_('QWCC001543'), // 운행지역
					prop: 'croRegnNm',
					minWidth: '150px',
					sortable: false,
					highlight: false
				},
				{
					label: this.getMessage_('QWCC001020'), // 운행지역의 상세지역
					prop: 'croDtlRegn',
					minWidth: '150px',
					sortable: false,
					highlight: false
				},
				{
					label: this.getMessage_('QWCC001021'), //연료전지사양
					prop: 'flclSpcNm',
					minWidth: '120px',
					sortable: false,
					highlight: false
				},
				{
					label: this.getMessage_('QWCC001351'), //보증기간(년)
					prop: 'usePrd',
					minWidth: '150px',
					sortable: false,
					highlight: false
				},
				{
					label: this.getMessage_('QWCC001023'), //보증사용거리(만Km)
					prop: 'milg',
					minWidth: '150px',
					sortable: false,
					highlight: false
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('reload', currentPageVal, pageUnitVal);
		},

		scrNameClick(row) {
			this.$emit('SendPmcData', row);
		}
	}
};
</script>

<style></style>
